import { CloseOutlined } from "@ant-design/icons";

const IconError: React.FC = () => (
	<CloseOutlined
		style={{
			backgroundColor: "#F8D7DA",
			color: "#D93025",
			fontSize: "25px",
			padding: "10px",
			borderRadius: "10px",
			border: "0.5px solid #D93025",
		}}
	/>
);
export default IconError;
